import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/access/access_1.jpg'
import _imports_1 from '@/assets/images/access/access_2.jpg'
import _imports_2 from '@/assets/images/access/access_3.jpg'


const _withScopeId = n => (_pushScopeId("data-v-77040c41"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-access" }
const _hoisted_2 = { class: "access-navi" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = {
  class: "link",
  href: "#vrchat"
}
const _hoisted_5 = { class: "item" }
const _hoisted_6 = {
  class: "link",
  href: "#resonite"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("VRChat")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Resonite")
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheDetailPageHeader = _resolveComponent("TheDetailPageHeader")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_SignalText = _resolveComponent("SignalText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheDetailPageHeader, { class: "page-access" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('page_title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_TheDetailPageBody, null, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_1')), 1),
          _createElementVNode("ul", _hoisted_2, [
            _createElementVNode("li", _hoisted_3, [
              _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$props.i18n.$text('menu', 'vrchat')), 1)
            ]),
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$props.i18n.$text('menu', 'resonite')), 1)
            ])
          ]),
          _createVNode(_component_Heading, {
            tag: "h2",
            class: "heading-platform",
            id: "vrchat"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_1', 'h2_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('group_1', 'li_1')), 1),
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_1', 'li_2')), 1),
              _createVNode(_component_LinkButton, { href: "/access/instances" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_1', 'link_1')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('group_1', 'li_3')), 1),
            _createElementVNode("li", null, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('group_1', 'li_4')), 1),
              _hoisted_8
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('group_1', 'li_5')), 1),
              _hoisted_9,
              _hoisted_10
            ])
          ]),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'caution_1')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'caution_2_1')), 1),
              _createVNode(_component_router_link, { to: "/program" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'link_1')), 1)
                ]),
                _: 1
              }),
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'caution_2_2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'caution_3')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_SignalText, { signal: "caution" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'caution_4')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, {
            tag: "h2",
            class: "heading-platform",
            id: "resonite"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_1', 'h2_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('resonite', 'text_1')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('resonite', 'text_2')), 1),
            _createElementVNode("li", null, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('resonite', 'text_3')), 1),
              _createElementVNode("p", null, [
                _createElementVNode("img", {
                  src: 
                _ctx.$props.i18n.locale.value === 'ja'
                  ? require('@/assets/images/access/access_6_ja.jpg')
                  : require('@/assets/images/access/access_6_en.jpg')
              ,
                  alt: ""
                }, null, 8, _hoisted_12)
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('resonite', 'text_4')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}